import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=316b3c1e"
import script from "./desktop.vue?vue&type=script&lang=js"
export * from "./desktop.vue?vue&type=script&lang=js"
import style0 from "./desktop.vue?vue&type=style&index=0&id=316b3c1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports